import { Link } from "react-router-dom"

function Error403() {

  return (
    <div className="pageContainer">
        <div className="error403 column">
            <div className="error403Title">
                Error 403
            </div>
            <div className="error403Body">
                acceso denegado
            </div>
            <div className="error403Button">
                <Link to="/">volver al inicio</Link>
            </div>
        </div>
    </div>
  )
}

export default Error403